import { find, has } from "ramda";

export const getOrgIdForProcessing = uploadSources => {
  const org = find(has("programOrganizationId"), uploadSources);
  return org?.programOrganizationId;
};
